import { render, staticRenderFns } from "./TwoFa.vue?vue&type=template&id=b8bedecc&scoped=true&"
import script from "./TwoFa.vue?vue&type=script&lang=js&"
export * from "./TwoFa.vue?vue&type=script&lang=js&"
import style0 from "./TwoFa.vue?vue&type=style&index=0&id=b8bedecc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8bedecc",
  null
  
)

export default component.exports